const THREE = require('three')
export let scene = new THREE.Scene()
export default scene
window.scene = scene


// WEBPACK FOOTER //
// ./src/components/game/scene.js